<template>
  <el-dialog
    width="50%"
    :visible.sync="showDialogInternal" >
    <template #title>
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
          <span>Email Settings</span>
        </div>
      </template>
    <div v-loading="isLoading">
      <div>
        <el-form ref="formDataRef" :model="formData" >
          <el-form-item 
            label="Email Recipients (use commas to separate multiple emails)"
            style="width: 100%;" 
          >
            <el-input
              v-model="formData.email"
              :rows="4"
              type="textarea"
            />
          </el-form-item>
        </el-form>
      </div>
      <div>
        <div style="display: flex; gap: 5px; justify-content: flex-end;">
          <el-button type="primary" @click="saveRecipients">Save</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getMpaEmailReceipients, saveMpaEmailReceipients } from '@/services/modules/ops.js'
export default {
  name: 'EmailSettings',
  props: {
    showEmailSettingsDialog: Boolean,
  },
  data () {
    return {
      showDialogInternal: false,
      isLoading: false,
      formData: {
        email: [],
        id: ''
      }
    }
  },
  mounted () {
    this.getReceipients()
  },
  computed: {
    disableForm () {
      return [4,5].includes(this.jobStatus)
    }
  },
  watch: {
    showEmailSettingsDialog (newVal, oldVal) {
      if (newVal) this.showDialogInternal = true
    },
    showDialogInternal (newVal, oldVal) {
      if (!newVal) this.$emit('on-dialog-closed')
    }
  },
  methods: {
    getReceipients () {
      this.isLoading = true
      getMpaEmailReceipients(this.jobId).then(res => {
        this.formData.email = res.data.email
        this.formData.id = res.data.id
      })
      .catch(() => {})
      .finally(() => this.isLoading = false)
    },
    saveRecipients () {
      this.isLoading = true
      const data = {
        ...this.formData
      }
      saveMpaEmailReceipients(data).then(res => {
        if (res.code === 1000) {
          this.$message.success('Successfully saved the email recipients.')
          this.getReceipients()
        }else{
          this.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto;
}
</style>
